const getAgenda = async (date) => fetch(`https://www.larinconada.es/api/eventos?token=ADD61523AAEFDD18822AA00&fecha=${date}`, {
  method: 'GET',
}).catch((error) => console.error('error:', error));

export default getAgenda;
